<template>
  <div class="container-denied">
    <div>{{ $t("access_denied") }}</div>
    <md-button class="md-primary" @click="back">{{ $t("back") }}</md-button>
  </div>
</template>

<script>
export default {
  name: "AccessDenied",
  methods: {
    back() {
      this.$router.push(`./`);
    },
  },
};
</script>

<style>
.container-denied {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: #eeeeee;
  align-items: center;
  justify-content: center;
}
</style>
